import React from 'react';
import Translation from '../../translation/translation';

const WheelsInfo = ({wheelsData}) => {
	const wheels2 = removeString(wheelsData.wheels_2);
	const wheels4 = removeString(wheelsData.wheels_4);
	return (
		<div className="fitting-price">
			{
				wheels2 !== '$0' ? 
					<Translation 
						translationKey='fitting-station-finder-overview-wheels-alignment-cost'
						placeholder={{ amount: 2, price: wheels2}}
					/> : (null)
			}
			<br/>
			{
				wheels4 !== '$0' ?
					<Translation 
						translationKey='fitting-station-finder-overview-wheels-alignment-cost'
						placeholder={{ amount: 4, price: wheels4}}
					/> : (null)
			}
		</div>
	);
};

const removeString = price => {
	return price.replace(/[^\d\$]/g, '');
}

export default WheelsInfo;